import React, { useState } from 'react';
import cn from 'classnames';
import { MuiSwitcher, SidebarMenu } from '@kaleyra/kds';
import { useHistory } from 'react-router-dom'

import Logo from './Logo';
import Styles from './KDSLeftSideBar.module.scss';
import { KaleyraLogo ,Title} from '@kaleyra/kds';
import { ArrowDown24Icon } from '@kaleyra/kds';
import VoiceDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=voice.svg';
import CampaignManagerImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=campaign manager.svg';
import ChatBotDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=chatbot.svg';
import FlowBuilderDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=flow Builder.svg';
import DialPad24Img from '@kaleyra/kds/src/assets/iconLibrary/icons-24px/DialPad.svg';
import VerifyDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=verify.svg';
import ConversationDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=conversation.svg';
import URLShortnerImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=url shortner.svg';
import SubaccountDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=subaccount.svg';
import FailOverDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=failover.svg';
import SMSDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=SMS.svg';
import EmailDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=email.svg';
import WhatsAppDuotoneImg from '@kaleyra/kds/src/assets/iconLibrary/duotone-tools/channel=whatsApp.svg';
import * as utils from '../../../utils';

export type SidebarMenuProps = React.ComponentProps<typeof SidebarMenu>[];

export type KDSLeftSideBarProps = {
	logoUrl?: string;
	className?: string;
	channelName: string;
	menu?: SidebarMenuProps;
};

const KDSLeftSideBar = ({
	logoUrl,
	channelName,
	className,
	menu,
}: KDSLeftSideBarProps) => {

	const [visible,setVisible] =useState(false)
const history = useHistory()

	const MuiSwitcherFooterType ={
		label:"Go Back To DashBoard",
		onClick:()=>{
			history.push(utils.defaultRedirectTo())
		}
	}
 const tools = [
		{
		  label: 'Campaign Manager',
		  image: <img src={CampaignManagerImg} className={className} alt="CampaignManager"></img>,
		  onClick: () => {
			history.push("/campaigns")
		  },
		},
		{
		  label: 'Chatbot',
		  image: <img src={ChatBotDuotoneImg} className={className} alt="ChatBotDuotone"></img>,
		  onClick: () => {
			history.push("/chatbot/overview")
		  },
		},
		{
		  label: 'Flow Builder',
		  image: <img src={FlowBuilderDuotoneImg} className={className} alt="FlowBuilderDuotone"></img>,
		  onClick: () => {
			history.push("/flow-builder/flows")
		  },
		},
		{
		  label: 'Numbers',
		  image: <img src={DialPad24Img} className={className} alt="DialPad24"></img>,
		  onClick: () => {
			history.push("/numbers/manage")
		  },
		},
		{
		  label: 'Verify',
		  image: <img src={VerifyDuotoneImg} className={className} alt="VerifyDuotone"></img>,
		  onClick: () => {
			history.push("/verify/dashboard")
		  },
		},
		{
		  label: 'Conversations',
		  image: <img src={ConversationDuotoneImg} className={className} alt="ConversationDuotone"></img>,
		  onClick: () => {
			history.push("/chatbot/overview")
		  },
		},
		{
		  label: 'URL Shortner',
		  image: <img src={URLShortnerImg} className={className} alt="URLShortnerDuotone"></img>,
		  onClick: () => {
			history.push("/conversations/dashboard")
		  },
		},
		{
		  label: 'Subaccount',
		  image: <img src={SubaccountDuotoneImg} className={className} alt="SubaccountDuotone"></img>,
		  onClick: () => {
			history.push("/subaccounts/manage-subaccounts")
		  },
		},
		{
		  label: 'Failover',
		  image: <img src={FailOverDuotoneImg} className={className} alt="FailOverDuotone"></img>,
		  onClick: () => {
			history.push(utils.defaultRedirectTo())
		  },
		},
	  ];
const channels = [
		{
		  label: 'SMS',
		  image: <img src={SMSDuotoneImg} className={className} alt="SMSDuotone"></img>,
		  greenTick: true,
		  onClick: () => {
			history.push("/channels/sms/sender-id")
		  },
		},
		{
		  label: 'Voice',
		  image: <img src={VoiceDuotoneImg} className={className} alt="VoiceDuotone"></img>,
		  greenTick: true,
		  onClick: () => {
			history.push("/channels/voice/logs")
		  },
		},
		{
		  label: 'Whatsapp',
		  image: <img src={WhatsAppDuotoneImg} className={className} alt="WhatsAppDuotone"></img>,
		  greenTick: true,
		  onClick: () => {
			history.push("/whatsapp/dashboard")
			// {TODO : passing url to the desired page not working}
		  },
		},
		{
		  label: 'Email',
		  image: <img src={EmailDuotoneImg} className={className} alt="EmailDuotone"></img>,
		  onClick: () => {
			history.push("/channels/email/logs")
		  },
		},
	  ];

	return (
		<div className={cn( 'sidebar sidebar-light accordion', Styles.menuContainer, className )} >
			{
				channelName === "Fallback" ?
				<div className={Styles.topSection} title="KaleyraLogo" >
				<div className='d-flex'>
				<KaleyraLogo />
				<Title weight="500" className='ml-2'>{channelName}</Title>
				</div>
				<MuiSwitcher title={'Switch To'}  tools= {tools} channels= {channels}  visible={visible}  updateVisible={setVisible } footerProps={MuiSwitcherFooterType}
						  relativePlacement={{
							top: 60,
							left: 0
						}}
						>
					<ArrowDown24Icon/></MuiSwitcher>
			    </div>
			
			: <Logo url={logoUrl} channelName={channelName} /> }

			<div className="mt-2">
				{menu?.map((menuItem) => {
					return <SidebarMenu {...menuItem} key={menuItem.label} />;
				})}
			</div>
		</div>
	);
};

export default KDSLeftSideBar;
